import { render, staticRenderFns } from "./VipDialogClock.vue?vue&type=template&id=34db1215&scoped=true&"
import script from "./VipDialogClock.vue?vue&type=script&lang=ts&"
export * from "./VipDialogClock.vue?vue&type=script&lang=ts&"
import style0 from "./VipDialogClock.vue?vue&type=style&index=0&id=34db1215&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34db1215",
  null
  
)

export default component.exports